module.exports = __webpack_public_path__ + "img/parallax.9b18db55.jpg";